<nav>
  <ul [ngClass]="'card-list-section'">
    <li [ngClass]="'page-cards'">
      <button
        [disabled]="currentPage === 1"
        (click)="onGoTo(1)">
        <img src="assets/icon/Move-To-Front.svg">
      </button>
    </li>
    <li [ngClass]="'page-cards'">
      <button
        [disabled]="currentPage === 1"
        (click)="onPrevious()">
        <img src="assets/icon/Move-Forward.svg">
      </button>
    </li>
    @for (page of pages; track page) {
      <li [ngClass]="'page-cards'">
        @if (getTensDigit(page - 1) === chapter) {
          <a  [ngClass]="page === currentPage ? 'Current Page, Page ' + page : 'Go to Page ' + page"
            [class.current]="page === currentPage"
            tabindex="0"
            (click)="onGoTo(page)"
            (keyup.enter)="onGoTo(page)">
            {{ page }}
          </a>
        } @else {
          <a  [ngClass]="page === currentPage ? 'Current Page, Page ' + page : 'Go to Page ' + page"
            [class.current]="page === currentPage"
            tabindex="0"
            (click)="onGoTo(page)"
            (keyup.enter)="onGoTo(page)">
            ...
          </a>
        }
      </li>
    }
    <li [ngClass]="'page-cards'">
      <button
        [disabled]="currentPage === totalPages"
        (click)="onNext()">
        <img src="assets/icon/Move-Back.svg">
      </button>
    </li>
    <li [ngClass]="'page-cards'">
      <button
        [disabled]="currentPage === totalPages"
        (click)="onGoTo(totalPages)">
        <img src="assets/icon/Move-To-Back.svg">
      </button>
    </li>
  </ul>
  <ul [ngClass]="'page-size-section'">
    <mat-select
      [formControl]="form.controls.pageSize"
      [ngClass]="'page-size-selector'"
      [value]="pageSizeOptions[0]"
      (selectionChange)="requestNewPageSize($event)">
      @for (size of pageSizeOptions; track size) {
        <mat-option [value]="size">
          {{size}}
        </mat-option>
      }
    </mat-select>
    <p> items per page </p>
  </ul>
  <ul [ngClass]="'chapter-description-section'">
    {{pageDescription}}
  </ul>
</nav>